import { useEffect } from 'react';
import MainContainer from '../components/layout/MainContainer';
import MoldOrderPrioritizer from '../components/MoldOrderPrioritizer';
import ErrorPage from '../components/pages/Error';
import { useMoldOrders } from '../hooks/useMoldOrders';
import { useLocation } from 'react-router-dom';
import TableListSkeleton from '../components/shared/TableListSkeleton';
import { useMoldOrderDetail } from '../hooks/useMoldOrder';
import { canSetPriority } from '../components/MoldDetail/utils';
import { useAppState } from '../context/AppStateContext';

const MoldOrderPrioritizerContainer: React.FC = () => {
  const { moldOrders, loading, error, fetchMoldOrders } = useMoldOrders();
  const { moldOrder, loading: singleMoldLoading, error: singleMoldError } = useMoldOrderDetail();
  const location = useLocation();
  const { getMoldOrderMainType } = useAppState();

  const queryParams = new URLSearchParams(location.search);
  const status = queryParams.get('status') || 'ALL';
  const moldOrderFirstLevelType = moldOrder ? getMoldOrderMainType(moldOrder.type) : 'maintenance';

  useEffect(() => {
    fetchMoldOrders();
  }, [fetchMoldOrders]);

  useEffect(() => {
    // Trigger a re-fetch when the status query parameter changes
    fetchMoldOrders();
  }, [status, fetchMoldOrders]);

  if (loading || singleMoldLoading) {
    return (
      <MainContainer>
        <TableListSkeleton />
      </MainContainer>
    );
  }
  if (error || singleMoldError) return <ErrorPage />;

  const filteredMoldOrders = moldOrders.filter((order) => canSetPriority(order.status));

  return (
    <MoldOrderPrioritizer
      moldOrders={filteredMoldOrders}
      currentMoldOrder={moldOrder}
      moldOrderFirstLevelType={moldOrderFirstLevelType}
    />
  );
};

export default MoldOrderPrioritizerContainer;
